;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a85c3d85-d56f-467f-b835-3aa7f4781d52",e._sentryDebugIdIdentifier="sentry-dbid-a85c3d85-d56f-467f-b835-3aa7f4781d52")}catch(e){}}();import { createContext } from 'react';
import '../_virtual/_sentry-release-injection-file.js';

const defaultContext = {
    multilanguage: false,
    availableLanguages: [],
    bonuspointsAvailable: true,
    helpLink: '',
    translations: new Map(),
    showSearch: true,
    showCategories: true,
    isArtificialCategoriesEnabled: false,
    categories: [],
    showCart: true,
    bundle: 'zooplus',
    brand: 'zooplus',
    mediaServerV2URL: '',
    cart: { summary: { articleCount: 0 } },
    securityIconsHTML: null,
    locale: 'de-DE',
    domain: '',
    translationsLocale: '',
    hoppsSearchUrl: '',
    hoppsSuggestionsUrl: '',
    vendorAssetsURL: '',
    isNextJS: false,
    siteId: -1,
    originalHost: '',
    isLoggedIn: false,
    customerStatusLoaded: false,
    customerId: -1,
    isError: false,
    searchFlyoutSponsoredTagEnabled: false,
    backendHeaderVersion: '',
};
const AppContext = createContext(defaultContext);

export { AppContext as default, defaultContext };
//# sourceMappingURL=AppContext.js.map
